import { render, staticRenderFns } from "./TariffOrganization.vue?vue&type=template&id=b63efd72&scoped=true&"
import script from "./TariffOrganization.vue?vue&type=script&lang=js&"
export * from "./TariffOrganization.vue?vue&type=script&lang=js&"
import style0 from "./TariffOrganization.vue?vue&type=style&index=0&id=b63efd72&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63efd72",
  null
  
)

export default component.exports